import { tbEvent, tbRound, TbEventWithId } from "@moment-golf/types";

/** Ensures rounds array exists, each round has challenges/sideGames, and pads missing rounds when totalRounds > rounds.length */
export function normalizeEventRounds<T extends tbEvent | TbEventWithId>(event: T | null | undefined): T | null | undefined {
    if (!event) return event;
    const totalRounds = Number(event.totalRounds) || 0;
    let rounds: any[] = Array.isArray(event.rounds) ? [...event.rounds] : [];

    // Ensure each round has challenges and sideGames as arrays
    rounds = rounds.map((r: any) => ({
        ...r,
        challenges: Array.isArray(r.challenges) ? r.challenges : [],
        sideGames: Array.isArray(r.sideGames) ? r.sideGames : [],
        startHole: r.startHole ?? 1,
    }));

    // If totalRounds exists and we have fewer rounds, pad with defaults
    if (totalRounds > 0 && rounds.length < totalRounds) {
        const template = rounds[0] ?? {};
        for (let i = rounds.length; i < totalRounds; i++) {
            rounds.push({
                ...template,
                roundNumber: i + 1,
                challenges: [],
                sideGames: [],
                courseID: event.courseID,
                courseName: event.courseName,
                scoreFormat: event.scoreFormat,
                playFormat: event.playFormat,
                playerVersus: event.playerVersus,
                startHole: template.startHole ?? 1,
            });
        }
        rounds.sort((a: any, b: any) => (a.roundNumber ?? 0) - (b.roundNumber ?? 0));
    }

    return { ...event, rounds };
}

export const validateEvent = async (event: tbEvent) => {

    const refEvent = JSON.stringify(event);

    // Checks to make sure all data is present
    const validatedEvent: tbEvent = {
        ...event,
        startDate: new Date(event.startDate),
        endDate: new Date(event.endDate),
        flighting: event.flighting || [],
        regPerTeeTime: event.regPerTeeTime || Math.floor(4 / event.regQty),
        privacyGroup: event.privacyGroup || null,
        privacyRegType: event.privacyRegType || null,
        privacyViewType: event.privacyViewType || null,
        privacyAccessType: event.privacyAccessType || null,
        waitList: event.waitList || 0,
        cutAfterRound: event.cutAfterRound || 0,
        cutPlayerCap: event.cutPlayerCap || 0,
        cutScoreCap: event.cutScoreCap || 0,
        teeSetNames: event.teeSetNames || null,
        teeSets: event.teeSets || [],
        roundLengthTarget: event.roundLengthTarget || 4.5,
        secondaryTeeOrderName: event.secondaryTeeOrderName || null,
        secondaryTeeOrderID: event.secondaryTeeOrderID || null,
        scoreMedium: event.scoreMedium || null,
        scoreType: event.scoreType || null,
        scoreFormat: event.scoreFormat || null,
        scoreVerification: event.scoreVerification || null,
        reqDigital: event.reqDigital || false,
        eventCode: event.eventCode || null,
        eventLink: event.eventLink || null,
        eventInfo: event.eventInfo || [],
        rounds: event.rounds || [],
        published: event.published || false,
        canceled: event.canceled || false,
        canceledBy: event.canceledBy || null,
        canceledAt: event.canceledAt || null,
        createdAt: new Date(),
        createdBy: event.userID,
        modifiedAt: new Date(),
        modifiedBy: event.userID,
        useTeams: event.useTeams || false,
        teamSize: event.teamSize || 0,
        playFormat: event.playFormat || null,
        totalHoles: event.totalHoles || 18
    }

    const newRounds: tbRound[] = [];
    event.rounds.forEach((round: any) => {
        newRounds.push({
            ...round,
            regPerTeeTime: event.regPerTeeTime || Math.floor(4 / event.regQty),
            roundDate: new Date(new Date(event.startDate).setDate(new Date(event.startDate).getDate() + (round.roundNumber - 1))),
            startingTime: '09:00:00',
            teeTimeGap: 10,
            startHole: round.startHole ?? 1,
            splitTees: false,
            teeSetNames: event.teeSetNames || null,
            teeSets: event.teeSets || [],
            shotgunStart: false,
            useBracket: false,
            matchRegions: 0,
            matchRegionRounds: 0,
            bracket: [],
            altOrderBreakPoint: 0,
            challenges: [],
            sideGames: [],
            canceled: false,
            canceledBy: null,
            canceledAt: null,
            createdAt: new Date(),
            createdBy: event.userID,
            modifiedAt: new Date(),
            modifiedBy: event.userID,
            playFormat: round.playFormat || null,
            holePoints: round.holePoints || [],
            pointSystem: round.pointSystem || null,
            usePoints: round.usePoints || false,
            mixedPlayFormats: round.mixedPlayFormats || []
        });
    });


    validatedEvent.rounds = newRounds;

    

    return validatedEvent;
}
